import React, { useState, useEffect } from "react";
import { Button, Divider, Dropdown, Modal } from "semantic-ui-react";
import { Document, Page } from "react-pdf";

const baseUrl = `/dealer`;

const isImage = (filename) => /\.(gif|jpg|jpeg|tiff|png)$/i.test(filename);

export default function SupplementalModal({
  open,
  onUpload,
  onDecline,
  onSupplementalDelete,
  uploaded,
}) {
  return (
    <Modal open={open} onClose={onDecline}>
      <Modal.Header
        content="Would you like to upload another document?"
        style={{ textAlign: "center" }}
      />
      <Modal.Content>
        <div style={{ textAlign: "center" }}>
          <Button
            as="label"
            icon="upload"
            content="Upload"
            color="green"
            labelPosition="right"
            htmlFor="supplementalDoc"
          />
          <Button content="No, I'm Done Here" onClick={onDecline} />
          <input
            hidden
            id="supplementalDoc"
            accept=".jpeg,.jpg,.gif,.png,.pdf"
            name="supplemental_doc"
            type="file"
            onChange={(e) => onUpload(e)}
          />
        </div>
        {uploaded.length > 0 && (
          <div style={{ textAlign: "center" }}>
            <Divider />
            <h3>
              ({uploaded.length}) Additional Document
              {uploaded.length === 1 ? "" : "s"} Uploaded
            </h3>
            <div className="doc-items">
              {uploaded.map((doc) => (
                <UploadedItem
                  key={doc.id}
                  originalFilename={doc.originalFilename}
                  src={`${baseUrl}/api/images/supplemental-document/${doc.filename}`}
                  onDelete={() => onSupplementalDelete(doc.filename)}
                />
              ))}
            </div>
          </div>
        )}
      </Modal.Content>
    </Modal>
  );
}

SupplementalModal.defaultProps = {
  open: false,
  uploaded: [],
};

function UploadedItem({ src, originalFilename, onDelete }) {
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const [pdf, setPdf] = useState(null);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (!isImage(src)) {
      setPdf(src);
    }
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function onNextPage(e) {
    e.preventDefault();

    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  }

  function onPreviousPage(e) {
    e.preventDefault();

    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  }

  return (
    <div className="uploaded-item">
      <div className="meta">
        <h3>{originalFilename}</h3>
        <Dropdown icon="ellipsis horizontal">
          <Dropdown.Menu>
            <Dropdown.Item
              text={isOpen ? "Close Preview" : "Open Preview"}
              icon={isOpen ? "eye slash" : "eye"}
              onClick={() => setOpen(!isOpen)}
            />
            <Dropdown.Divider />
            <Dropdown.Item text="Delete" icon="trash" onClick={onDelete} />
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {isOpen && (
        <div>
          {pdf && (
            <div style={{ minHeight: "100px" }}>
              <a href={src} target="_blank">
                <Document
                  // loading={<Loader active content="Loading PDF..." />}
                  file={src}
                  onLoadSuccess={onDocumentLoadSuccess}
                  renderMode="svg"
                >
                  <Page scale={0.9} pageNumber={pageNumber} />
                </Document>
              </a>
              <Button
                icon="arrow left"
                circular
                onClick={onPreviousPage}
                disabled={pageNumber === 1 ? true : false}
              />
              <Button
                icon="arrow right"
                circular
                onClick={onNextPage}
                disabled={pageNumber === numPages ? true : false}
              />
            </div>
          )}
          {isImage(src) && (
            <a href={src} target="_blank">
              <img
                src={src}
                style={{
                  display: "block",
                  margin: "0 auto",
                  maxWidth: "100%",
                }}
              />
            </a>
          )}
        </div>
      )}
    </div>
  );
}
